function patchCartIconButton(): void {
  const buttons = Array.from(document.querySelectorAll('button'));
  const realCartButton = buttons.find((button) =>
    (button.textContent || '').toLowerCase().includes('carrello preventivi')
  );

  if (!realCartButton) return;

  const iconButton = buttons.find((button) => {
    const hasCartIcon = button.querySelector('svg.lucide-shopping-cart');
    const hasNoText = (button.textContent || '').trim() === '';
    return hasCartIcon && hasNoText;
  });

  if (!iconButton || iconButton.dataset.cartLinked === '1') return;

  iconButton.dataset.cartLinked = '1';
  iconButton.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      realCartButton.click();
    },
    true
  );
}

export function initCartIconBridge(): void {
  let scheduled = false;

  const schedulePatch = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      patchCartIconButton();
    });
  };

  patchCartIconButton();

  const observer = new MutationObserver(schedulePatch);
  observer.observe(document.body, { childList: true, subtree: true });
}
